module.exports = __webpack_public_path__ + "static/viano-embassy-3f537b5ef431950475b0c62d3041796f.jpg";